import { createApi } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

import anonymizingFetchBaseQuery from '../anonymizingBaseQuery'
import { prepareAuthHeaderWithoutOrg } from '../headers'
import fastApiParamsSerializer from '../paramsSerializer'

// Requests are scoped to the signed-in principal and never name the cloaked organization.
const baseQuery = anonymizingFetchBaseQuery({
  baseUrl: envConfig.serviceUrls.ders,
  prepareHeaders: prepareAuthHeaderWithoutOrg,
  paramsSerializer: fastApiParamsSerializer
})

// eslint-disable-next-line import/prefer-default-export
export const api = createApi({
  reducerPath: 'dersApi',
  baseQuery,
  endpoints: () => ({})
})
